import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class EventsService {
  constructor() {}

  publishEvent(eventName: string, data: any) {
    const customEvent = new CustomEvent(eventName, {
      detail: data,
    });

    window.dispatchEvent(customEvent);
  }
}
